/**
 * Resolve session modality (in-person / telehealth / hybrid) from Appointment FHIR fields.
 * Matches calendar event logic — distinct from service type (e.g. Couples Therapy).
 */
import type { Appointment } from '@medplum/fhirtypes';

export type AppointmentSessionModality = 'in-person' | 'telehealth' | 'hybrid';

export const APPOINTMENT_MODALITY_OPTIONS = [
  { value: 'in-person' as const, label: 'In-person' },
  { value: 'telehealth' as const, label: 'Telehealth' },
  { value: 'hybrid' as const, label: 'Hybrid' },
];

export function resolveAppointmentModality(appointment: Appointment): AppointmentSessionModality {
  const apptTypeCodings = appointment.appointmentType?.coding ?? [];
  for (const coding of apptTypeCodings) {
    const display = coding.display?.toLowerCase() ?? '';
    if (display.includes('hybrid')) return 'hybrid';
    if (coding.code === 'VR' && display.includes('hybrid')) return 'hybrid';
    if (display.includes('telehealth') || display.includes('virtual')) {
      return 'telehealth';
    }
    if (coding.code === 'VR') return 'telehealth';
  }

  const apptTypeText = appointment.appointmentType?.text?.toLowerCase() ?? '';
  if (apptTypeText.includes('hybrid')) return 'hybrid';
  if (apptTypeText.includes('telehealth') || apptTypeText.includes('virtual')) {
    return 'telehealth';
  }

  return 'in-person';
}
